import React, { useEffect, useState } from "react";
import DashboardLayout from "@layouts/dashboard/dashboard-layout";
import { getValue, setValue } from "@utils/lodash";
import { useNavigate } from "react-router-dom";
import NavigationBar from "@components/NotificationBar/index";
import DeleteModal from "@_common/deleteModal";
import { toast } from "react-toastify";
import PaginationPage from "@components/pagination/pagination";
import SearchHeader from "@components/common/SearchHeader";
import { adminDeleteSpecificOrganization } from "@services/client-list.service";
import Notfound from "@components/Not-Found";
import moment from "moment";
import Loader from "@components/common/Loader";
import FilterForm from "@components/common/Compliance-AddFilter/FilterForm";
import {
  adminGetCountriesListManagement,
  adminGetListManagementGroupCode,
  adminGetStatesListManagement,
  getSmartFilterCategoryOfLawList,
  getSmartFilterLegislationList,
  getSmartFilterLegislationRuleList,
} from "@services/list-management.service";
import { adminGetCheckpoint } from "@services/checkpoint.service";
import { useParams } from "react-router-dom";
import { formatText } from "@_common/format-text";
import {
  clientGetFunction,
  clientGetLocation,
} from "@services/location.service";
import {
  addAllTaskLicenseTask,
  downloadLiscenseTask,
  getUpdateActiveStatusLicenceTask,
  updateLicenseTaskOwner,
} from "@services/license.service";
import { NavLink } from "react-router-dom";
import { QueryRequestHelper } from "@_common/query-request-helper";
import NoAccessPage from "@components/common/NoAccess";
import DatePicker from "react-datepicker";
import FilterSearchDropdown from "@_common/FilterSearchDropdown";
import ScrollableReactTable from "@components/ScrollableDatatable";
import { tableStatusStyle } from "@_common/colors";
import { convertCurrentDate } from "@_common/date-helpers";
import MenuActivitySvgComponent from "../../../assets/svg-components/left-menu/menuactivity";
import RightMenuHeaders from "@components/common/RightMenuHeaders";
import { countKeysWithValues } from "@_common/text-helpers";
import { allParams } from "@_common/common-helper";
import ChangeOwnerModal from "@pages/Repository/popup/changeOwnerModal";
import { adminGetUsers } from "@services/users.service";
import _ from "lodash";
import { CalendarDays, EllipsisVertical } from "lucide-react";

interface IComplianceTaskListProps { }

const ComplianceTaskList: React.FunctionComponent<IComplianceTaskListProps> = (
  props: any,
) => {
  let navigate = useNavigate();
  let mainParams = useParams();

  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const [isLoading, setIsLoading] = React.useState(true);
  const [list, setList] = React.useState<[]>([]);
  const [isFilterVisible, setFilterVisibility] = React.useState(false);
  const [complianceTypeList, setComplianceTypeList] = useState([]);
  const [filterIsOpen, setFilterIsOpen] = useState(false);
    const [showMenu, setShowMenu] = useState(false);

  const handleFilter = () => {
    setFilterIsOpen(!filterIsOpen);
  };

  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */
  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length === 0 && props.permissionAPITriggered) {
      navigate(`${window.location.pathname}?${QueryRequestHelper({ is_active: "true" })}`);
      getData();
      getCountriesList();
      getLocations();
      getDropdownInfo();
      getSmartFilterList();
      setDate(new Date());
      getCategoryLawList("", "", "");
      getLegislationList("", "", "");
      getLegislationRuleList("", "", "");
      getLocationList("", "");
      // getLocationFunctions('', '', '')
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length > 0 && props.permissionAPITriggered) {
      getData();
      getCountriesList();
      getLocations();
      getDropdownInfo();
      getSmartFilterList();
      getLocationList("", getValue(params, `location_id`, ""));
      if (params.page_no) {
        setPage_no(parseInt(params.page_no));
      }
      if (params.search_text) {
        setSearchInput(params.search_text);
        setShowSearchTextbox(true);
      }
      if (params.limit) {
        setLimit(parseInt(params.limit));
      }
      if (params.date) {
        setDate(new Date(params.date));
      } else {
        setDate(new Date());
      }
      if (params.expiry_date_from) {
        setExpiry_date_from(new Date(params.expiry_date_from));
      }
      if (params.expiry_date_to) {
        setExpiry_date_to(new Date(params.expiry_date_to));
      }
      if (params.follow_up_date_from) {
        setFollow_up_date_from(new Date(params.follow_up_date_from));
      }
      if (params.follow_up_date_to) {
        setFollow_up_date_to(new Date(params.follow_up_date_to));
      }
      setRequest({
        country_id: getValue(params, `country_id`, "101"),
        state_id: getValue(params, `state_id`, ""),
        category_of_law_id: getValue(params, `category_of_law_id`, ""),
        legislation_id: getValue(params, `legislation_id`, ""),
        legislation_rule_id: getValue(params, `legislation_rule_id`, ""),
        frequency_id: getValue(params, `frequency_id`, ""),
        location_id:
          getValue(mainParams, `id`, "") === "id"
            ? ""
            : getValue(params, `location_id`, ""),
        function_id: getValue(params, `function_id`, ""),
        checkpoint_id: getValue(params, `checkpoint_id`, ""),
      });
      if (getValue(params, `country_id`, "")) {
        setFilterVisibility(true);
        getStatesList(getValue(params, `country_id`, ""));
      }
      if (
        getValue(params, `state_id`, "") ||
        getValue(params, `category_of_law_id`, "") ||
        getValue(params, `legislation_id`, "") ||
        getValue(params, `legislation_rule_id`, "") ||
        getValue(params, `location_id`, "")
      ) {
        getCategoryLawList(
          "",
          getValue(params, `state_id`, ""),
          getValue(params, `category_of_law_id`, ""),
        );
        getLegislationList(
          "",
          getValue(params, `state_id`, ""),
          getValue(params, `legislation_id`, ""),
        );
        getLegislationRuleList(
          "",
          getValue(params, `legislation_id`, ""),
          getValue(params, `legislation_rule_id`, ""),
        );
        getLocationList("", getValue(params, `location_id`, ""));
        getLocationFunctions(
          "",
          getValue(params, `location_id`, ""),
          getValue(params, `function_id`, ""),
        );
      } else {
        getCategoryLawList("", "", "");
        getLegislationList("", "", "");
        getLegislationRuleList("", "", "");
        getLocationList("", "");
        // getLocationFunctions('', '', '')
      }
    }
  }, [window.location.href, props.permissionAPITriggered]);
  const [smartFilterList, setSmartFilterList] = useState([]);
  const [selectedSmartFilterIds, setSelectedSmartFilterIds] = useState<any>([]);
  const handleChangeSelectMulti = (e: any) => {
    setSelectedSmartFilterIds(e);
  };
  const getSmartFilterList = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");

    try {
      let resp = await adminGetListManagementGroupCode("smart-filter");
      if (resp) {
        let list =
          getValue(resp, `data.listItems.length`, 0) > 0
            ? getValue(resp, `data.listItems`, []).filter((item: object) =>
              getValue(item, `is_active`, ""),
            )
            : [];
        let obj = list.map((item: object) => ({
          id: getValue(item, `id`, ""),
          is_active: getValue(item, `is_active`, ""),
          text: getValue(item, `text`, ""),
          value: getValue(item, `text`, ""),
          label: getValue(item, `text`, ""),
        }));
        setSmartFilterList(obj);
        if (getValue(selectedIDs, `length`, 0) > 0) {
          let arr: [] | any = [];
          selectedIDs.map((item: object) => {
            let filtered = obj.filter((ob: any) => ob.id == item);
            if (getValue(filtered, `length`, 0) > 0) {
              arr.push(filtered[0]);
            }
          });
          setSelectedSmartFilterIds(arr);
        }
      } else {
      }
    } catch (error) { }
  };

  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const [isLoading1, setIsLoading1] = useState(false);
  const getLocations = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      page_no: 1,
      page_size: 10,
      is_active: true,
      is_user_request: true,
      id: mainParams.id === "id" ? "" : mainParams.id,
      // search_text: getValue(localStorage, `task_license_loc`, "")
      // 	? getValue(localStorage, `task_license_loc`, "")
      // 	: getValue(params, `loc_search_text`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading1(true);
      let resp = await clientGetLocation(queryRequest);
      if (resp) {
        let list = getValue(resp, `data.locations`, []).map((item: any) => ({
          ...item,
          value: getValue(item, `location_name`, ""),
          label: getValue(item, `location_name`, ""),
        }));
        setComplianceTypeList(list);

        setSelectedValue(
          getValue(list, `length`, 0) > 0
            ? list.filter((item: any) => item.id === mainParams.id)[0]
            : {},
        );
        setIsLoading1(false);
      } else {
        setIsLoading1(false);
      }
    } catch (error) {
      setIsLoading1(false);
    }
  };
  const getData = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");

    let dates = params.date ? new Date(params.date) : new Date();
    var firstDay = params.firstDay
      ? params.firstDay
      : new Date(dates.getFullYear(), dates.getMonth(), 1);
    var lastDay = params.lastDay
      ? params.lastDay
      : new Date(dates.getFullYear(), dates.getMonth() + 1, 0);

    let compliance_task_ids: any = urlSearchParams.getAll(
      "compliance_task_ids[]",
    );

    let userSpec = getValue(localStorage, `user`, {});
    let user: any = JSON.parse(userSpec);

    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: params.limit ? parseInt(params.limit) : limit,
      search_text: params.search_text,
      // from_date: moment(firstDay).format("YYYY-MM-DD"),
      // to_date: moment(lastDay).format("YYYY-MM-DD"),

      expiry_date_from: getValue(params, `expiry_date_from`, "")
        ? getValue(params, `expiry_date_from`, "")
        : null,
      expiry_date_to: getValue(params, `expiry_date_to`, "")
        ? getValue(params, `expiry_date_to`, "")
        : null,
      follow_up_date_from: getValue(params, `follow_up_date_from`, "")
        ? getValue(params, `follow_up_date_from`, "")
        : null,
      follow_up_date_to: getValue(params, `follow_up_date_to`, "")
        ? getValue(params, `follow_up_date_to`, "")
        : null,
      // country_id: getValue(request, `country_id`, ""),
      // state_id: getValue(request, `state_id`, ""),
      category_of_law_id: getValue(request, `category_of_law_id`, ""),
      // legislation_id: getValue(request, `legislation_id`, ""),
      // legislation_rule_id: getValue(request, `legislation_rule_id`, ""),
      location_id:
        getValue(mainParams, `id`, "") === "id"
          ? ""
          : getValue(mainParams, `id`, ""),
      frequency_id: getValue(params, `frequency_id`, "")
        ? getValue(params, `frequency_id`, "")
        : getValue(request, `frequency_id`, ""),
      license_task_ids: compliance_task_ids,
      // location_id: getValue(params, `location_id`, "")
      // 	? getValue(params, `location_id`, "")
      // 	: getValue(request, `location_id`, ""),
      function_id: getValue(params, `function_id`, "")
        ? getValue(params, `function_id`, "")
        : getValue(request, `function_id`, ""),
      checkpoint_id: getValue(params, `checkpoint_id`, "")
        ? getValue(params, `checkpoint_id`, "")
        : getValue(request, `checkpoint_id`, ""),
      request_from: getValue(params, `request_from`, ""),
      request_type: getValue(params, `request_type`, ""),
      request_value: getValue(params, `request_value`, ""),
      smart_filter_tags: selectedIDs,
      sort_expiry_date: params.sort_expiry_date,
      sort_follow_up_date: params.sort_follow_up_date,
      // is_active: params.is_active === "true" ? "true" : (params.is_active === "false" ? "false" : undefined),
      is_active: params.is_active === "false" ? "false" : "true",
      ...(params.request_from !== "dashboard" && {
        do_not_show_expired:
          params.request_value === "expired_license" ? "false" : "true",
      }),
    };

    if (getValue(props, `permissions`, []).includes("view_all")) {
      payload.is_user_request = "false";
    }

    let queryRequest = QueryRequestHelper(payload);

    try {
      setIsLoading(true);
      let resp = await addAllTaskLicenseTask(queryRequest);
      if (resp) {
        setList(
          getValue(resp, `data.license_tasks`, []).map((item: object) => ({
            ...item,
            checkpoint_id: getValue(
              item,
              `license.checkpoint.checkpoint_id`,
              "",
            ),
            category_of_law: getValue(
              item,
              `license.checkpoint.category_of_law.text`,
              "",
            ),
            legislation: getValue(
              item,
              `license.checkpoint.legislation.legislation_name`,
              "",
            ),
            frequency: getValue(item, `license.checkpoint.frequency.text`, ""),
            license_type: getValue(item, `license.license_type.text`, ""),
            license_type_id: getValue(item, `license.license_type.id`, ""),
            rule: getValue(
              item,
              `license.checkpoint.legislation_rule.rule_name`,
              "",
            ),
            compliance_status_formatted: formatText(
              getValue(item, `compliance_status`, ""),
            ),
            compliance_activity: getValue(
              item,
              `license.checkpoint.compliance_activity`,
              "",
            ),
            legal_due_date: getValue(item, `legal_due_date`, "")
              ? moment(getValue(item, `legal_due_date`, "")).format(
                "DD MMM YYYY",
              )
              : "",
            follow_up_date: getValue(item, `follow_up_date`, "")
              ? moment(getValue(item, `follow_up_date`, "")).format(
                "DD MMM YYYY",
              )
              : "",
            expiry_date: getValue(item, `expiry_date`, "")
              ? convertCurrentDate(getValue(item, `expiry_date`, ""))
              : "",
            status: getValue(item, `is_active`, false) ? "Active" : "Inactive",
            city_name: getValue(item, `city.name`, ""),
            industry: getValue(item, `industry.text`, ""),
            business_type: getValue(item, `business_type.text`, ""),
            location: getValue(item, `license.location.location_name`, ""),
            location_id: getValue(item, `license.location.id`, ""),
            function: getValue(item, `function.function_name`, ""),
          })),
        );
        setTotalCount(getValue(resp, `data.pagination.total`, 0));
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Search section                               */
  /* -------------------------------------------------------------------------- */
  const [showSearchTextbox, setShowSearchTextbox] = useState(false);
  const [search_text, setSearchInput] = useState<any>("");

  const toggleSearch = () => {
    setShowSearchTextbox((prevState) => !prevState);
  };
  const toggleSearchClose = () => {
    setSearchInput("");
    toggleSearch();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (params.search_text) {
      delete params.search_text;
      let payload: any = { ...params };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      getData();
    }
  };

  const handleChangeSearch = async (e: any) => {
    if (e.target.value) {
      setSearchInput(e.target.value);
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload: any = {
        ...params,
        page_no: 1,
        search_text: e.target.value,
      };
      // let payload: any = { ...params };

      // removing null values
      // Object.keys(payload).forEach((key) => {
      // 	if (!payload[key] || payload[key] === undefined) {
      // 		delete payload[key];
      // 	}
      // });
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      if (!e.target.value) {
        getData();
      }
    } else {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      setSearchInput(e.target.value);
      delete params.search_text;
      let queryRequest = QueryRequestHelper(params);
      navigate(`${window.location.pathname}?${queryRequest}`);
      if (!e.target.value) {
        getData();
      }
    }
  };

  const [selectedIDs, setSelectedIDs] = useState<any>([]);
  const getTableState = (value: object) => {
    let selectedIndexList = Object.keys(
      getValue(value, `selectedRowIds`, {}),
    ).map((item) => parseInt(item));
    let selectedIds =
      list.length > 0
        ? list.filter((_item: object, index: number) =>
          selectedIndexList.includes(index),
        )
        : [];
    if (selectedIds.length > 0) {
      setSelectedIDs(
        selectedIds.map((item: object) => getValue(item, `id`, "")),
      );
    } else {
      setSelectedIDs([]);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                                 Delete section                             */
  /* -------------------------------------------------------------------------- */

  const [deleteValue, setDeleteValue] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const handleDeleteFun = (id: string, value: string) => {
    setDeleteValue(value);
    setDeleteId(id);
    handleDelete();
  };
  const [isDelete, setIsDelete] = useState(false);
  const handleDelete = () => {
    setIsDelete(!isDelete);
  };

  const handleDeleteFunction = async () => {
    try {
      let resp = await adminDeleteSpecificOrganization(deleteId);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        handleDelete();
        getData();
      }
    } catch (error) { }
  };

  /* -------------------------------------------------------------------------- */
  /*                               Onchange section                             */
  /* -------------------------------------------------------------------------- */

  const handleChangeSortBy = (value: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    params.sort_by = value;
    props.history.push({
      pathname: window.location.pathname,
      query: params,
    });
  };

  const handleChangeStatus = (name: string, value: string) => {
    if (value) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      if (name === "sort_expiry_date") {
        delete params.sort_follow_up_date;
      }
      if (name === "sort_follow_up_date") {
        delete params.sort_expiry_date;
      }
      let payload = {
        ...params,
        [name]: value,
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    } else {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let payload = {
        ...params,
        [name]: "",
        page_no: 1,
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    }
    // window.location.reload()
  };
  /* -------------------------------------------------------------------------- */
  /*                               Pagination section                           */
  /* -------------------------------------------------------------------------- */

  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page_no, setPage_no] = useState(1);

  const handleChangePagination = (page_no: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let compliance_task_ids: any = urlSearchParams.getAll(
      "compliance_task_ids[]",
    );

    let payload = {
      ...params,
      page_no: page_no,
      compliance_task_ids: compliance_task_ids,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleChangeLimit = (limit: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let compliance_task_ids: any = urlSearchParams.getAll(
      "compliance_task_ids[]",
    );

    let payload = {
      ...params,
      page_no: 1,
      limit: limit,
      compliance_task_ids: compliance_task_ids,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };

  const handleEdit = (id: string) => {
    navigate(`/configuration/vendors/add/${id}`);
  };
  const rowClick = (obj: object) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    // let dates = params.date ? new Date(params.date) : new Date();
    // var firstDay = new Date(dates.getFullYear(), dates.getMonth(), 1);
    // var lastDay = new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
    const mainpParms = {
      group_id: params.group_id,
      region_id: params.region_id,
    };
    let queryRequest = QueryRequestHelper(mainpParms);
    if (
      getValue(obj, `original.id`, "") &&
      getValue(obj, `original.license.checkpoint.id`, "") &&
      getValue(obj, `original.location_id`, "") &&
      getValue(obj, `original.license_type_id`, "")
    ) {
      navigate(
        `/activities/task/license/list/detail/${getValue(
          obj,
          `original.id`,
          "",
        )}/${getValue(obj, `original.license.checkpoint.id`, "")}/${getValue(
          obj,
          `original.location_id`,
          "",
        )}/${getValue(obj, `original.license_type_id`, "")}?${queryRequest}`,
      );
    } else {
    }
  };

  const HeaderButton = ({ lablel, name }: any) => {
    return (
      <div className="d-flex">
        <span>{lablel}</span>&nbsp;&nbsp;&nbsp;
        <p className="cursor-pointer" onClick={() => handleClickSort(name)}>
          ^
        </p>
      </div>
    );
  };
  const switchFilter = (name: string) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let value = getValue(params, `${name}`, "")
      ? getValue(params, `${name}`, "")
      : "newest";
    switch (value) {
      case "newest":
        return "oldest";
      case "oldest":
        return "newest";
      default:
        return "newest";
    }
  };
  const handleClickSort = (name: string) => {
    handleChangeStatus(name, switchFilter(name));
  };
  const getTrProps = (rowInfo: any) => {
    if (getValue(rowInfo, `id`, "")) {
      return {
        style: tableStatusStyle(getValue(rowInfo, `compliance_status`, "")),
      };
    }
    return {};
  };
  const columns = React.useMemo(
    () => [
      {
        Header: "Checkpoint ID",
        accessor: "checkpoint_id",
        width: 200,
        Cell: ({ row }: any) => {
          return (
            // <NavLink to={`/configuration/vendors/detail/${row.original.id}`}>
            <>{row.values.checkpoint_id}</>
            // </NavLink>
          );
        },
      },
      {
        Header: "License Task ID",
        accessor: "license_task_id",
        width: 200,
      },

      // {
      // 	Header: "Category of Law",
      // 	accessor: "category_of_law",
      // 	width: 200,
      // },
      // {
      // 	Header: "Legislation",
      // 	accessor: "legislation",
      // 	width: 300,
      // },
      // {
      // 	Header: "Rule",
      // 	accessor: "rule",
      // 	width: 200,
      // },
      // {
      // 	Header: "Frequency",
      // 	accessor: "frequency",
      // 	width: 300,
      // },
      // {
      // 	Header: "Renewal Date",
      // 	accessor: "legal_due_date",
      // 	width: 200,
      // },
      {
        Header: "Location",
        accessor: "location",
        width: 200,
      },

      {
        Header: "License Type",
        accessor: "license_type",
        width: 200,
      },
      {
        Header: "License Status",
        accessor: "license_status",
        width: 200,
      },
      {
        Header: "Approval Status",
        accessor: "approved_status",
        width: 200,
      },

      {
        // Header: "Followup Date",
        Header: (
          <HeaderButton lablel="Followup Date" name="sort_follow_up_date" />
        ),
        accessor: "follow_up_date",
        width: 200,
      },
      {
        // Header: "Expiry Date",
        Header: <HeaderButton lablel="Expiry Date" name="sort_expiry_date" />,
        accessor: "expiry_date",
        width: 200,
      },
      {
        Header: "Status",
        accessor: "status",
        width: 200,
      },
      // 		 {
      //   	Header: "Action",
      //   	width: 170,
      //   	Cell: ({ row }: any) => {
      //   		return (
      //   			<>
      //   				<Button
      //   					color="primary"
      //   					onClick={() => handleEdit(row.original.id)}
      //   				>
      //   					Edit
      //   				</Button>
      //   			</>
      //   		);
      //   	},
      //   },
    ],
    [],
  );

  const handleChangeActiveStatus = async (value: string) => {
    try {
      let resp = await getUpdateActiveStatusLicenceTask({
        ids: selectedIDs,
        is_active: value === "active" ? true : false,
      });
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        setSelectedIDs([]);
        getData();
      } else {
        getData();
      }
    } catch (error) { }
  };

  const [check, setCheck] = useState(false);
  const handleRemoveNavItems = () => {
    setCheck(!check);
    setSelectedIDs([]);
  };
  const handleNavigate = (id: string) => {
    delete params.page_no;
    delete params.loc_search_text;
    let payload = {
      ...params,
      page_no: 1,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`/activities/task/license/list/${id}?${queryRequest}`);
  };

  /* -------------------------------------------------------------------------- */
  /*                              Date Routes                                   */
  /* -------------------------------------------------------------------------- */
  const [date, setDate] = useState<Date | null>(null);
  const handleSubmitDate = () => {
    let dates = moment(date).format("YYYY-MM-DD");
    let payload: any = {
      date: dates,
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
  };
  let selectedCompliance = complianceTypeList.filter(
    (item: any) => item.id == mainParams.id,
  );

  const handleNavigateCalenderView = () => {
    if (mainParams.id !== "id") {
      navigate(`/activities/task/license/list/calenderView/${mainParams.id}`);
    } else {
      toast.error("Please Open List Under Tasks");
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                           Date Filter Section                              */
  /* -------------------------------------------------------------------------- */
  const [expiry_date_from, setExpiry_date_from] = useState<Date | null>(null);
  const [expiry_date_to, setExpiry_date_to] = useState<Date | null>(null);

  const [follow_up_date_from, setFollow_up_date_from] = useState<Date | null>(
    null,
  );
  const [follow_up_date_to, setFollow_up_date_to] = useState<Date | null>(null);
  const loacalAllTime = localStorage.getItem("allTime");
  const [isAllTime, setIsAllTime] = React.useState(
    params.isAllTime ? params.isAllTime : loacalAllTime,
  );

  const handleSubmitExpiryDate = (
    fromOrEvent?: Date | React.MouseEvent<HTMLButtonElement> | undefined,
    to?: Date,
    defaultActive = false,
  ) => {
    if (isAllTime === "true") {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      delete params.expiry_date_from;
      delete params.expiry_date_to;

      let payload: any = { ...params };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);

      setExpiry_date_from(null);
      setExpiry_date_to(null);
      return;
    }

    let from: Date | null = null;
    let toDate: Date | null = null;

    if (fromOrEvent instanceof Date) {
      from = fromOrEvent;
      toDate = to ?? null;
    }

    const first = from
      ? moment(from).format("YYYY-MM-DD")
      : expiry_date_from && moment(expiry_date_from).format("YYYY-MM-DD");

    const last = toDate
      ? moment(toDate).format("YYYY-MM-DD")
      : expiry_date_to && moment(expiry_date_to).format("YYYY-MM-DD");

    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    delete params.follow_up_date_from;
    delete params.follow_up_date_to;
    setFollow_up_date_from(null);
    setFollow_up_date_to(null);

    if (first && last && first !== "Invalid date" && last !== "Invalid date") {
      let payload: any = {
        ...params,
        expiry_date_from: first,
        expiry_date_to: last,
        ...(defaultActive && !params.is_active ? { is_active: "true" } : {}),
      };
      if (payload.expiry_date_from && payload.expiry_date_to) {
        let queryRequest = QueryRequestHelper(payload);
        navigate(`${window.location.pathname}?${queryRequest}`);
      } else {
        toast.error("Start Date and End Date Required");
      }
    } else {
      toast.error("Please select date");
    }
  };

  const handleToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.checked ? "true" : "false";
    setIsAllTime(newValue);
    localStorage.setItem("allTime", newValue);
  };

  useEffect(() => {
    const startOfMonth = moment().startOf("month").toDate();
    const endOfMonth = moment().endOf("month").toDate();
    setExpiry_date_from(startOfMonth);
    setExpiry_date_to(endOfMonth);
    handleSubmitExpiryDate(startOfMonth, endOfMonth, true);
  }, []);

  useEffect(() => {
    if (isAllTime === "true") {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());

      delete params.expiry_date_from;
      delete params.expiry_date_to;
      if (!params.is_active) {
        params.is_active = "true";
      }

      let payload: any = { ...params };
      let queryRequest = QueryRequestHelper(payload);

      navigate(`${window.location.pathname}?${queryRequest}`);
      setExpiry_date_from(null);
      setExpiry_date_to(null);
    } else {
      const startOfMonth = moment().startOf("month").toDate();
      const endOfMonth = moment().endOf("month").toDate();
      setExpiry_date_from(startOfMonth);
      setExpiry_date_to(endOfMonth);
      const first = moment(startOfMonth).format("YYYY-MM-DD");
      const last = moment(endOfMonth).format("YYYY-MM-DD");

      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      delete params.follow_up_date_from;
      delete params.follow_up_date_to;

      let payload: any = {
        ...params,
        expiry_date_from: first,
        expiry_date_to: last,
        ...(!params.is_active ? { is_active: "true" } : {}),
      };

      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
    }
  }, [isAllTime]);

  const handleSubmitFollowupDate = () => {
    let first =
      follow_up_date_from && moment(follow_up_date_from).format("YYYY-MM-DD");
    let last =
      follow_up_date_to && moment(follow_up_date_to).format("YYYY-MM-DD");
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    delete params.expiry_date_from;
    delete params.expiry_date_to;
    setExpiry_date_from(null);
    setExpiry_date_to(null);
    if (first && last && first !== "Invalid date" && last !== "Invalid date") {
      let payload: any = {
        ...params,
        follow_up_date_from: first,
        follow_up_date_to: last,
      };
      if (payload.follow_up_date_from && payload.follow_up_date_to) {
        let queryRequest = QueryRequestHelper(payload);
        navigate(`${window.location.pathname}?${queryRequest}`);
      } else {
        toast.error("Start Date and End Date Required");
      }
    } else {
      toast.error("Please select date");
    }
  };

  const handleExpiryDate = (date: any) => {
    setExpiry_date_from(date[0]);
    setExpiry_date_to(date[1]);
  };
  const handleFollowupDate = (date: any) => {
    setFollow_up_date_from(date[0]);
    setFollow_up_date_to(date[1]);
  };

  /* -------------------------------------------------------------------------- */
  /*                       Location Search Section                              */
  /* -------------------------------------------------------------------------- */
  const searchLocations = (inputText: string): void => {
    searchHere(inputText);
  };
  const searchHere = async (inputText: string) => {
    let payload: any = {
      page_no: 1,
      page_size: 10,
      is_active: true,
      search_text: inputText,
      is_user_request: true,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      let resp = await clientGetLocation(queryRequest);
      if (resp) {
        setComplianceTypeList(
          getValue(resp, `data.locations`, []).map((item: any) => ({
            ...item,
            value: getValue(item, `location_name`, ""),
            label: getValue(item, `location_name`, ""),
          })),
        );
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                      New Location Search Section                           */
  /* -------------------------------------------------------------------------- */

  const [selectedValue, setSelectedValue] = useState({});
  const [searchLoading, setSearchLoading] = useState(false);
  const handleTriggerAPI = async (value: string) => {
    let payload: any = {
      page_no: 1,
      page_size: 10,
      is_active: true,
      search_text: value,
      is_user_request: true,
    };
    setSearchLoading(true);
    let queryRequest = QueryRequestHelper(payload);
    try {
      let resp = await clientGetLocation(queryRequest);
      if (resp) {
        setComplianceTypeList(
          getValue(resp, `data.locations`, []).map((item: any) => ({
            ...item,
            value: getValue(item, `location_name`, ""),
            label: getValue(item, `location_name`, ""),
          })),
        );
        setSelectedValue({});
        setSearchLoading(false);
      } else {
        setSearchLoading(false);
      }
    } catch (error) {
      setSearchLoading(false);
    }
  };
  const handleClick = (e: any) => {
    setSelectedValue(e);
    handleSelectLocation(e);
  };

  const handleSelectLocation = (e: any) => {
    handleNavigate(getValue(e, `id`, ""));
  };

  const [checkpointList, setCheckpointList] = useState([]);

  const getAllCheckpoint = async () => {
    let payload: any = {
      page_no: params.page_no ? parseInt(params.page_no) : 1,
      page_size: 100,
      country_id: getValue(request, `country_id`, ""),
      state_id: getValue(request, `state_id`, ""),
      category_of_law_id: getValue(request, `category_of_law_id`, ""),
      legislation_id: getValue(request, `legislation_id`, ""),
      legislation_rule_id: getValue(request, `legislation_rule_id`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);

    let resp = await adminGetCheckpoint(queryRequest);
    if (resp) {
      setCheckpointList(
        getValue(resp, `data.checkpoints`, []).map((item: object) => ({
          value: getValue(item, `checkpoint_id`, ""),
          label: getValue(item, `checkpoint_id`, ""),
          id: getValue(item, `id`, ""),
        })),
      );
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                                  Smart Filters                             */
  /* -------------------------------------------------------------------------- */

  const [request, setRequest] = useState<any>({
    country_id: "101",
    state_id: "",
    category_of_law_id: "",
    legislation_id: "",
    legislation_rule_id: "",
    frequency_id: "",
    location_id: "",
    function_id: "",
    checkpoint_id: "",
  });

  useEffect(() => {
    getAllCheckpoint();
  }, [
    request.country_id,
    request.state_id,
    request.category_of_law_id,
    request.legislation_id,
    request.legislation_rule_id,
  ]);

  useEffect(() => {
    getStatesList(request.country_id);
  }, [request.country_id]);

  const [countryList, setCountryList] = useState([]);
  const [states, setStates] = useState([]);
  const [frequencyList, setFrequencyList] = useState([]);

  const reset = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let payload: any = {
      page_no: params.page_no,
      search_text: getValue(params, `search_text`, ""),
      limit: getValue(params, `limit`, ""),
    };
    let queryRequest = QueryRequestHelper(payload);
    navigate(`${window.location.pathname}?${queryRequest}`);
    getData();
    reset1();
  };
  const [resetInput, setResetInput] = useState(false);
  const reset1 = () => {
    setRequest({
      ...request,
      // country_id: "",
      state_id: "",
      category_of_law_id: "",
      legislation_id: "",
      legislation_rule_id: "",
      location_id: "",
      function_id: "",
    });
    setSelectedSmartFilterIds([]);
    setResetInput(true);
  };

  const getCountriesList = async () => {
    try {
      let resp = await adminGetCountriesListManagement();
      if (resp) {
        setCountryList(
          getValue(resp, `data.countries`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `name`, ""),
            label: getValue(item, `name`, ""),
          })),
        );
      } else {
      }
    } catch (error) { }
  };

  const getStatesList = async (countryId: number) => {
    if (countryId) {
      try {
        let resp = await adminGetStatesListManagement(countryId);
        if (resp) {
          setStates(
            getValue(resp, `data.states`, []).map((item: object) => ({
              ...item,
              value: getValue(item, `name`, ""),
              label: getValue(item, `name`, ""),
            })),
          );
        } else {
        }
      } catch (error) { }
    }
  };

  /* ---------------------------  Category Of Law  ----------------------------- */
  const [categoryOfLawList, setCategoryOfLawList] = useState([]);
  const [categoryLawLoading, setCategoryLawLoading] = useState(false);
  const getCategoryLawList = async (
    value: string,
    state_id: string,
    id: string,
  ) => {
    try {
      setResetInput(false);
      setCategoryLawLoading(true);
      let payload = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        state_id: state_id ? state_id : getValue(request, `state_id`, ""),
        // state_id: state_id,
        id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSmartFilterCategoryOfLawList(queryRequest);
      if (resp) {
        setCategoryOfLawList(
          getValue(resp, `data.stateCategoryOfLaw`, []).map((item: object) => ({
            // ...item,
            // id: getValue(item, `category_of_law.id`, ""),
            id: getValue(item, `id`, ""),
            value: getValue(item, `category_of_law.text`, ""),
            label: getValue(item, `category_of_law.text`, ""),
          })),
        );
        setCategoryLawLoading(false);
        setValue(request, `category_of_law_id`, "");
      } else {
        setCategoryLawLoading(false);
      }
    } catch (error) {
      setCategoryLawLoading(false);
    }
    if (!value) {
      setValue(request, `category_of_law_id`, "");
    }
  };

  /* ---------------------------  Legislation  ----------------------------- */
  const [legislationList, setLegislationList] = useState([]);
  const [legislationLoading, setLegislationLoading] = useState(false);
  const getLegislationList = async (
    value: string,
    state_id: string,
    id: string,
  ) => {
    try {
      setResetInput(false);
      setLegislationLoading(true);
      let payload = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        state_id: state_id ? state_id : getValue(request, `state_id`, ""),
        // state_id: state_id,
        id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSmartFilterLegislationList(queryRequest);
      if (resp) {
        setLegislationList(
          getValue(resp, `data.legislations`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `legislation_name`, ""),
            label: getValue(item, `legislation_name`, ""),
          })),
        );
        setLegislationLoading(false);
        setValue(request, `legislation_id`, "");
      } else {
        setLegislationLoading(false);
      }
    } catch (error) {
      setLegislationLoading(false);
    }
    if (!value) {
      setValue(request, `legislation_id`, "");
    }
  };

  /* ---------------------------  Legislation Rule  ----------------------------- */
  const [ruleList, setRuleList] = useState([]);
  const [legislationRuleLoading, setLegislationRuleLoading] = useState(false);
  const getLegislationRuleList = async (
    value: string,
    legislation_id: string,
    id: string,
  ) => {
    try {
      setResetInput(false);
      setLegislationRuleLoading(true);
      let payload = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        legislation_id: legislation_id
          ? legislation_id
          : getValue(request, `legislation_id`, ""),
        id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getSmartFilterLegislationRuleList(queryRequest);
      if (resp) {
        setRuleList(
          getValue(resp, `data.legislationRules`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `rule_name`, ""),
            label: getValue(item, `rule_name`, ""),
          })),
        );
        setLegislationRuleLoading(false);
        setValue(request, `legislation_rule_id`, "");
      } else {
        setLegislationRuleLoading(false);
      }
    } catch (error) {
      setLegislationRuleLoading(false);
    }
    if (!value) {
      setValue(request, `legislation_rule_id`, "");
    }
  };

  /* ---------------------------  Locations  ----------------------------- */
  const [locationLoading, setLocationLoading] = useState(false);
  const [locations, setLocations] = useState([]);

  const getLocationList = async (value: string, id: string) => {
    try {
      setResetInput(false);
      setLocationLoading(true);
      let payload: any = {
        page_no: 1,
        page_size: 10,
        search_text: value,
        id: id,
        is_user_request: true,
      };
      let queryRequest = QueryRequestHelper(payload);
      let locations = await clientGetLocation(queryRequest);
      if (locations) {
        setLocations(
          getValue(locations, `data.locations`, []).map((item: object) => ({
            value: getValue(item, `location_name`, ""),
            label: getValue(item, `location_name`, ""),
            id: getValue(item, `id`, ""),
          })),
        );
        setLocationLoading(false);
        setValue(request, `legislation_rule_id`, "");
      } else {
        setLocationLoading(false);
      }
    } catch (error) {
      setLocationLoading(false);
    }
    if (!value) {
      setValue(request, `location_id`, "");
      getLocationFunctions("", "", "");
    }
  };

  /* ---------------------------  Functions  ----------------------------- */
  const [functionLoading, setFunctionLoading] = useState(false);
  const [functions, setFunctions] = useState([]);

  const getLocationFunctions = async (
    value: string,
    location_id: string,
    id: string,
  ) => {
    let payload: any = {
      page_no: 1,
      page_size: 10,
      search_text: value,
      location_id: location_id,
      id: id,
    };
    let queryRequest = QueryRequestHelper(payload);
    try {
      setResetInput(false);
      setFunctionLoading(true);
      let resp = await clientGetFunction(queryRequest);
      if (resp) {
        setFunctions(
          getValue(resp, `data.functions`, []).map((item: object) => ({
            value: getValue(item, `function_name`, ""),
            label: getValue(item, `function_name`, ""),
            id: getValue(item, `id`, ""),
          })),
        );
        setFunctionLoading(false);
        setValue(request, `function_id`, "");
      } else {
        setFunctionLoading(false);
      }
    } catch (error) {
      setFunctionLoading(false);
    }
    if (!value) {
      setValue(request, `function_id`, "");
    }
  };

  /* ---------------------------  Onchange Smart filter  ----------------------------- */

  const handleChangeSelect = (e: any, type: string) => {
    if (type === "country_id") {
      getStatesList(e.id);
      setStates([]);
      setCategoryOfLawList([]);
      setLegislationList([]);
      setRuleList([]);
      setRequest({
        ...request,
        country_id: e.id,
        state_id: "",
        category_of_law_id: "",
        legislation_id: "",
        legislation_rule_id: "",
      });
    }
    if (type === "state_id") {
      if (!getValue(e, `id`, "")) {
        setValue(request, `state_id`, "");
        setRequest({
          ...request,
          // state_id: '',
          category_of_law_id: "",
          legislation_id: "",
          legislation_rule_id: "",
        });
        getCategoryLawList("", "", "");
        getLegislationList("", "", "");
        getLegislationRuleList("", "", "");
      } else {
        setRequest({
          ...request,
          state_id: getValue(e, `id`, "") ? getValue(e, `id`, "") : "",
          category_of_law_id: "",
          legislation_id: "",
          legislation_rule_id: "",
        });
        getCategoryLawList("", getValue(e, `id`, ""), "");
        getLegislationList("", getValue(e, `id`, ""), "");
        setCategoryOfLawList([]);
        setLegislationList([]);
        setRuleList([]);
      }
    }
    if (type === "category_of_law_id") {
      setRequest({
        ...request,
        category_of_law_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "legislation_id") {
      getLegislationRuleList("", getValue(e, `id`, "") ? e.id : "", "");
      setRequest({
        ...request,
        legislation_id: getValue(e, `id`, "") ? e.id : "",
        legislation_rule_id: "",
      });
    }
    if (type === "legislation_rule_id") {
      setRequest({
        ...request,
        legislation_rule_id: getValue(e, `id`, "") ? e.id : "",
      });
      getAllCheckpoint();
    }
    if (type === "frequency_id") {
      setRequest({
        ...request,
        frequency_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "location_id") {
      setRequest({
        ...request,
        location_id: getValue(e, `id`, "") ? getValue(e, `id`, "") : "",
      });
      getLocationFunctions("", getValue(e, `id`, ""), "");
    }
    if (type === "function_id") {
      setRequest({
        ...request,
        function_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
    if (type === "checkpoint_id") {
      setRequest({
        ...request,
        checkpoint_id: getValue(e, `id`, "") ? e.id : "",
      });
    }
  };

  const handleSubmitSmartFilter = () => {
    let selectedSmartFilterIdsPayload = JSON.parse(
      JSON.stringify(selectedSmartFilterIds),
    );
    if (
      getValue(request, `country_id`, "")
      // && getValue(request, `category_of_law_id`, "") &&
      // getValue(request, `legislation_id`, "") &&
      // getValue(request, `legislation_rule_id`, "")
    ) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      let dates = params.date ? new Date(params.date) : new Date();
      var firstDay = new Date(dates.getFullYear(), dates.getMonth(), 1);
      var lastDay = new Date(dates.getFullYear(), dates.getMonth() + 1, 0);
      let payload: any = {
        ...params,
        page_no: params.page_no ? parseInt(params.page_no) : 1,
        page_size: params.limit ? parseInt(params.limit) : limit,
        search_text: params.search_text,
        status: "active",
        sort_by: params.sort_by,
        from_date: moment(firstDay).format("YYYY-MM-DD"),
        to_date: moment(lastDay).format("YYYY-MM-DD"),
        country_id: getValue(request, `country_id`, ""),
        state_id: getValue(request, `state_id`, ""),
        category_of_law_id: getValue(request, `category_of_law_id`, ""),
        legislation_id: getValue(request, `legislation_id`, ""),
        legislation_rule_id: getValue(request, `legislation_rule_id`, ""),
        // compliance_type_id: getValue(mainParams, `id`, ""),
        frequency_id: getValue(request, `frequency_id`, ""),
        location_id: getValue(request, `location_id`, ""),
        function_id: getValue(request, `function_id`, ""),
        checkpoint_id: getValue(request, `checkpoint_id`, ""),
        smart_filter_tags:
          selectedSmartFilterIdsPayload.length > 0
            ? selectedSmartFilterIdsPayload.map((item: object) =>
              getValue(item, `id`, ""),
            )
            : [],
      };
      let queryRequest = QueryRequestHelper(payload);
      navigate(`${window.location.pathname}?${queryRequest}`);
      // getData();
    } else {
      toast.error("All fields are mandatory");
    }
  };

  const getDropdownInfo = async () => {
    let payload: any = {
      page_no: 1,
      page_size: 100,
    };
    let queryRequest = QueryRequestHelper(payload);
    let frequency = await adminGetListManagementGroupCode("frequency");
    if (frequency) {
      let list =
        getValue(frequency, `data.listItems.length`, 0) > 0
          ? getValue(frequency, `data.listItems`, []).filter((item: object) =>
            getValue(item, `is_active`, ""),
          )
          : [];
      setFrequencyList(
        list.map((item: object) => ({
          value: getValue(item, `text`, ""),
          label: getValue(item, `text`, ""),
          id: getValue(item, `id`, ""),
        })),
      );
    }
  };

  let country_ID =
    getValue(countryList, `length`, 0) > 0 &&
    countryList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `country_id`, ""),
    );
  let state_ID =
    getValue(states, `length`, 0) > 0 &&
    states.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `state_id`, ""),
    );
  let cat_ID =
    getValue(categoryOfLawList, `length`, 0) > 0 &&
    categoryOfLawList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `category_of_law_id`, ""),
    );
  let leg_ID =
    getValue(legislationList, `length`, 0) > 0 &&
    legislationList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `legislation_id`, ""),
    );
  let rule_ID =
    getValue(ruleList, `length`, 0) > 0 &&
    ruleList.filter(
      (item: object) =>
        getValue(item, `id`, "") ==
        getValue(request, `legislation_rule_id`, ""),
    );
  let frequency_id =
    getValue(frequencyList, `length`, 0) > 0 &&
    frequencyList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `frequency_id`, ""),
    );
  let location_id =
    getValue(locations, `length`, 0) > 0 &&
    locations.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `location_id`, ""),
    );
  let function_id =
    getValue(functions, `length`, 0) > 0 &&
    functions.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `function_id`, ""),
    );
  let checkpoint_id =
    getValue(checkpointList, `length`, 0) > 0 &&
    checkpointList.filter(
      (item: object) =>
        getValue(item, `id`, "") == getValue(request, `checkpoint_id`, ""),
    );

  let queryRequest = QueryRequestHelper({
    page_no: getValue(params, `loc_page_no`, 1),
    search_text: getValue(params, `loc_search_text`, ""),
  });

  const handleDownloadLicenseTask = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    let selectedIDs: any = urlSearchParams.getAll("smart_filter_tags[]");
    let compliance_task_ids: any = urlSearchParams.getAll(
      "compliance_task_ids[]",
    );
    let userSpec = getValue(localStorage, `user`, {});
    let user: any = JSON.parse(userSpec);
    let payload: any = {
      search_text: params.search_text,
      expiry_date_from: getValue(params, `expiry_date_from`, "")
        ? getValue(params, `expiry_date_from`, "")
        : null,
      expiry_date_to: getValue(params, `expiry_date_to`, "")
        ? getValue(params, `expiry_date_to`, "")
        : null,
      follow_up_date_from: getValue(params, `follow_up_date_from`, "")
        ? getValue(params, `follow_up_date_from`, "")
        : null,
      follow_up_date_to: getValue(params, `follow_up_date_to`, "")
        ? getValue(params, `follow_up_date_to`, "")
        : null,
      category_of_law_id: getValue(request, `category_of_law_id`, ""),
      location_id:
        getValue(mainParams, `id`, "") === "id"
          ? ""
          : getValue(mainParams, `id`, ""),
      frequency_id: getValue(params, `frequency_id`, "")
        ? getValue(params, `frequency_id`, "")
        : getValue(request, `frequency_id`, ""),
      license_task_ids: compliance_task_ids,
      function_id: getValue(params, `function_id`, "")
        ? getValue(params, `function_id`, "")
        : getValue(request, `function_id`, ""),
      checkpoint_id: getValue(params, `checkpoint_id`, "")
        ? getValue(params, `checkpoint_id`, "")
        : getValue(request, `checkpoint_id`, ""),
      request_from: getValue(params, `request_from`, ""),
      request_type: getValue(params, `request_type`, ""),
      request_value: getValue(params, `request_value`, ""),
      smart_filter_tags: selectedIDs,
      sort_expiry_date: params.sort_expiry_date,
      sort_follow_up_date: params.sort_follow_up_date,
    };

    if (getValue(props, `permissions`, []).includes("view_all")) {
      payload.is_user_request = "false";
    }

    let queryRequest = QueryRequestHelper(payload);
    try {
      setIsLoading(true);
      let resp = await downloadLiscenseTask(queryRequest);
      if (resp) {
        toast.success(getValue(resp, `message`, ""));
        navigate(`/self-compliance-logs/LICENSE_TASK_DOWNLOAD_ALL_DOCS`);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  // ------------Change Owner--------------------

  const [isOpen, setIsOpen] = useState(false);
  const [userList, setUsersList] = useState([]);
  const [userLoading, setUserLoading] = useState(false);
  const [submitUserLoading, setSubmitUserLoading] = useState(false);
  const [request1, setRequest1] = useState({
    type: "",
    id: "",
  });
  const handleModal = () => {
    setIsOpen(!isOpen);
  };
  const getUsersList = async (search: string, id: string) => {
    try {
      let user: any = JSON.parse(getValue(localStorage, `user`, ""));
      let payload: any = {
        page_no: 1,
        page_size: 10,
        search_text: search || "",
        user_type: "CLIENT",
        org_id: getValue(user, `org_id`, ""),
        id: id,
      };
      let queryRequest = QueryRequestHelper(payload);
      setUserLoading(true);
      let resp = await adminGetUsers(queryRequest);
      if (resp) {
        setUserLoading(false);
        setUsersList(
          getValue(resp, `data.users`, []).map((item: any) => ({
            ...item,
            value:
              getValue(item, `first_name`, "") +
              " " +
              getValue(item, `last_name`, ""),
            label:
              getValue(item, `first_name`, "") +
              " " +
              getValue(item, `last_name`, ""),
          })),
        );
        setRequest1({
          ...request1,
          type: "",
          id: "",
        });
      } else {
        setUserLoading(false);
      }
    } catch (error) {
      setUserLoading(false);
    }
    if (!search) {
      setRequest1({
        ...request1,
        id: "",
      });
    }
  };

  const handleSubmitChangeUser = async () => {
    try {
      if (getValue(request1, `type`, "") && getValue(request1, `id`, "")) {
        setSubmitUserLoading(true);

        let payload: any = {
          ids: selectedIDs,
        };

        if (request1.type === "executor") {
          payload.assigned_to = getValue(request1, `id`, "") || null;
        } else if (request1.type === "evaluator") {
          payload.assigned_evaluator = getValue(request1, `id`, "") || null;
        }

        let resp = await updateLicenseTaskOwner(payload);

        if (resp) {
          setSubmitUserLoading(false);
          toast.success(getValue(resp, `message`, ""));
          getData();
          setIsOpen(false);
          setRequest1({
            ...request1,
            type: "",
            id: "",
          });
        } else {
          setSubmitUserLoading(false);
        }
      } else {
        toast.error("All fields are mandatory");
      }
    } catch (error) {
      setSubmitUserLoading(false);
    }
  };

  const handleChangeSelectUser = (e: any, type: string) => {
    if (type === "user") {
      setRequest1({
        ...request1,
        id: getValue(e, `id`, "") ? e.id : "",
      });
    }
  };

  useEffect(() => {
    if (isOpen) {
      getUsersList("", "");
    }
  }, [isOpen]);

  const getURL = () => {
    const paramsStr = allParams();
    const params = new URLSearchParams(paramsStr);

    if (params.has("search_text")) {
      params.delete("search_text");
    } else {
      allParams();
    }

    return params.toString();
  };
  return (
    <DashboardLayout
      permissions={getValue(props, `tabPermissionList`, [])}
      subTabPermissionList={getValue(props, `subTabPermissionList`, [])}
    >
      {!isLoading &&
        !getValue(props, `subTabPermissionList`, []).includes(
          "activities_licenses",
        ) ? (
        <NoAccessPage />
      ) : (
        <>
          {getValue(selectedIDs, `length`, 0) > 0 &&
            getValue(props, `permissions`, []).includes("take_action") && (
              <NavigationBar
                selectedIDs={selectedIDs}
                handleChangeActiveStatus={handleChangeActiveStatus}
                text={"MARK INACTIVE"}
                multi={
                  getValue(props, `permissions`, []).includes("update")
                    ? true
                    : false
                }
                handleRemoveNavItems={handleRemoveNavItems}
              />
            )}
          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <NavLink
                to={
                  getValue(params, `request_from`, "") === "dashboard"
                    ? `/dashboard/license?from_date=${getValue(
                      params,
                      `from_date`,
                      "",
                    )}&to_date=${getValue(params, `to_date`, "")}`
                    : `/activities/task/license?${getURL()}`
                }
                className="me-2"
              >
                <img
                  src="/images/back-link.svg"
                  className="img-fluid add-filter-wrapper__upload-image"
                  alt=""
                />
              </NavLink>

              <div className="header-parent-icon-holder">
                <MenuActivitySvgComponent />
              </div>

              <div className="title-wrapper me-2">
                <h6 className="dashbaord-wrapper__header-parent-title">
                  Activities
                </h6>
                <h4 className="dashbaord-wrapper__header-title">License</h4>
              </div>

              <FilterSearchDropdown
                placeholder={"Search Location"}
                options={complianceTypeList}
                searchLoading={searchLoading}
                handleChange={(val: any) => handleTriggerAPI(val)}
                handleClick={handleClick}
                value={selectedValue}
                label="label"
                id="id"
              />
            </div>

            <div className="d-flex align-items-center">
              <div className="d-flex align-items-center flex-nowrap mx-2">
                <h4
                  className="header_text__blue mb-0 me-2"
                  style={{ whiteSpace: "nowrap" }}
                >
                  All Time
                </h4>
                <div className="choicelist-wrapper custom-switch-wrapper">
                  <label className="switch mb-0">
                    <input
                      type="checkbox"
                      checked={isAllTime === "true"}
                      onChange={handleToggle}
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
              </div>
              <div
                className="follow-up-date-wrapper d-flex align-items-center mb-1"
              >
                {/* <div className="no-bordered-input-calendar mr-2">
                  <DatePicker
                    selectsRange={false}
                    selected={follow_up_date_from ? new Date(follow_up_date_from) : null}
                    className="react-date-picker__inputGroup__input"
                    onChange={(date: any) => {
                      if (date && follow_up_date_to && new Date(date) > new Date(follow_up_date_to)) {
                        toast.error("From Date cannot be greater than To Date");
                      } else {
                        handleFollowupDate([date, follow_up_date_to]);
                      }
                    }}
                    dateFormat="d MMM yyyy"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="Followup From Date"
                    maxDate={follow_up_date_to ? new Date(follow_up_date_to) : undefined}
                  />
                </div>
                <div className="no-bordered-input-calendar mr-2">
                  <DatePicker
                    selectsRange={false}
                    selected={follow_up_date_to ? new Date(follow_up_date_to) : null}
                    className="react-date-picker__inputGroup__input"
                    onChange={(date: any) => {
                      if (follow_up_date_from && date && new Date(follow_up_date_from) > new Date(date)) {
                        toast.error("To Date cannot be less than From Date");
                      } else {
                        handleFollowupDate([follow_up_date_from, date]);
                      }
                    }}
                    dateFormat="d MMM yyyy"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="Followup To Date"
                    minDate={follow_up_date_from ? new Date(follow_up_date_from) : undefined}
                  />
                </div> */}
                <div className="d-flex align-items-center">
                  <div className="d-flex align-items-end ">

                    {/* From Date */}
                    <div className="d-flex flex-column ">
                      <label className="filter-label mb-1">
                        Followup From Date
                      </label>

                      <div className="date-picker-wrapper">
                        <DatePicker
                          selected={follow_up_date_from ? new Date(follow_up_date_from) : null}
                          onChange={(date: Date | null) => {
                            handleFollowupDate([date, follow_up_date_to]);
                          }}
                          className="custom-date-input"
                          placeholderText="DD/MM/YYYY"
                          dateFormat="d MMM yyyy"
                          maxDate={follow_up_date_to ? new Date(follow_up_date_to) : undefined}
                        />

                        <CalendarDays size={18} className="date-picker-icon" />
                      </div>
                    </div>

                    {/* To Date */}
                    <div className="d-flex flex-column  ">
                      <label className="filter-label mb-1">
                        Followup To Date
                      </label>

                      <div className="date-picker-wrapper">
                        <DatePicker
                          selected={follow_up_date_to ? new Date(follow_up_date_to) : null}
                          onChange={(date: Date | null) => {
                            handleFollowupDate([follow_up_date_from, date]);
                          }}
                          className="custom-date-input"
                          placeholderText="DD/MM/YYYY"
                          dateFormat="d MMM yyyy"
                          minDate={follow_up_date_from ? new Date(follow_up_date_from) : undefined}
                        />

                        <CalendarDays size={18} className="date-picker-icon" />
                      </div>
                    </div>
                    <button
                      className="dashboard-wrapper__apply-btn"
                      onClick={handleSubmitFollowupDate}
                    >
                      Apply
                    </button>
                  </div>
                </div>

              </div>
              <div className="d-flex align-items-center mb-1">
                <div className="d-flex align-items-end gap-1">                {/* <div className="no-bordered-input-calendar mr-2 ms-2">
                  <DatePicker
                    selectsRange={false}
                    selected={expiry_date_from ? new Date(expiry_date_from) : null}
                    className="react-date-picker__inputGroup__input"
                    onChange={(date: any) => {
                      if (date && expiry_date_to && new Date(date) > new Date(expiry_date_to)) {
                        toast.error("From Date cannot be greater than To Date");
                      } else {
                        handleExpiryDate([date, expiry_date_to]);
                      }
                    }}
                    dateFormat="d MMM yyyy"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="Expiry From Date"
                    maxDate={expiry_date_to ? new Date(expiry_date_to) : undefined}
                  />
                </div> */}
                  <div className="d-flex flex-column ms-2 mr-2">

                    <label className="filter-label">
                      Expiry From Date
                    </label>

                    <div className="date-picker-wrapper">
                      <DatePicker
                        selectsRange={false}
                        selected={expiry_date_from ? new Date(expiry_date_from) : null}
                        className="custom-date-input"
                        onChange={(date: any) => {
                          if (date && expiry_date_to && new Date(date) > new Date(expiry_date_to)) {
                            toast.error("From Date cannot be greater than To Date");
                          } else {
                            handleExpiryDate([date, expiry_date_to]);
                          }
                        }}
                        dateFormat="d MMM yyyy"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        placeholderText="Expiry From Date"
                        maxDate={expiry_date_to ? new Date(expiry_date_to) : undefined}
                      />

                      <CalendarDays size={18} className="date-picker-icon" />
                    </div>

                  </div>
                  {/* <div className="no-bordered-input-calendar mr-2">
                  <DatePicker
                    selectsRange={false}
                    selected={expiry_date_to ? new Date(expiry_date_to) : null}
                    className="react-date-picker__inputGroup__input"
                    onChange={(date: any) => {
                      if (expiry_date_from && date && new Date(expiry_date_from) > new Date(date)) {
                        toast.error("To Date cannot be less than From Date");
                      } else {
                        handleExpiryDate([expiry_date_from, date]);
                      }
                    }}
                    dateFormat="d MMM yyyy"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="Expiry To Date"
                    minDate={expiry_date_from ? new Date(expiry_date_from) : undefined}
                  />
                </div> */}
                  <div className="d-flex flex-column mr-2">

                    <label className="filter-label">
                      Expiry To Date
                    </label>

                    <div className="date-picker-wrapper">
                      <DatePicker
                        selectsRange={false}
                        selected={expiry_date_to ? new Date(expiry_date_to) : null}
                        className="custom-date-input"
                        onChange={(date: any) => {
                          if (expiry_date_from && date && new Date(expiry_date_from) > new Date(date)) {
                            toast.error("To Date cannot be less than From Date");
                          } else {
                            handleExpiryDate([expiry_date_from, date]);
                          }
                        }}
                        dateFormat="d MMM yyyy"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        placeholderText="Expiry To Date"
                        minDate={expiry_date_from ? new Date(expiry_date_from) : undefined}
                      />

                      <CalendarDays size={18} className="date-picker-icon" />
                    </div>

                  </div>
                  <button
                    className="dashboard-wrapper__apply-btn ml-2"
                    onClick={handleSubmitExpiryDate}
                  >
                    Apply
                  </button>
                </div>


                {/* <RightMenuHeaders
                  //search
                  isSearch={true}
                  searchInput={search_text}
                  showSearchTextbox={showSearchTextbox}
                  toggleSearch={toggleSearch}
                  toggleSearchClose={toggleSearchClose}
                  handleChangeSearch={handleChangeSearch}
                  //smartFilter
                  smartFilter={false}
                  handleFilter={handleFilter}
                  //Calendar
                  calendarViewActivitiesLicense={true}
                  handleNavigateCalenderView={handleNavigateCalenderView}
                  //Line Seperator of button
                  lineSeperator={true}
                  selectedFilterCount={countKeysWithValues(params)}
                  downloadAssignTask={true}
                  handleDownload={handleDownloadLicenseTask}
                  changeOwner={
                    getValue(props, `permissions`, []).includes("view_all")
                      ? true
                      : false
                  }
                  isOpen={isOpen}
                  handleModal={
                    getValue(selectedIDs, `length`, 0) > 0
                      ? handleModal
                      : () => toast.error("Please select task")
                  }
                /> */}
                 <div style={{ position: "relative" }}>
   <button
  onClick={() => setShowMenu(!showMenu)}
  style={{
    display: "flex",
    alignItems: "center",
    background: "none",
    border: "none",
    cursor: "pointer",
  }}
>
  <EllipsisVertical size={20} />
</button>

    {showMenu && (
      <div
        style={{
          position: "absolute",
          right: 0,
          top: "100%",
          zIndex: 1000,
          background: "#fff",
          border: "1px solid #ddd",
          borderRadius: "8px",
          padding: "8px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        }}
      >
        <RightMenuHeaders
                  //search
                  isSearch={true}
                  searchInput={search_text}
                  showSearchTextbox={showSearchTextbox}
                  toggleSearch={toggleSearch}
                  toggleSearchClose={toggleSearchClose}
                  handleChangeSearch={handleChangeSearch}
                  //smartFilter
                  smartFilter={false}
                  handleFilter={handleFilter}
                  activeStatusFilter={true}
                  //Calendar
                  calendarViewActivitiesLicense={true}
                  handleNavigateCalenderView={handleNavigateCalenderView}
                  //Line Seperator of button
                  lineSeperator={true}
                  selectedFilterCount={countKeysWithValues(params)}
                  downloadAssignTask={true}
                  handleDownload={handleDownloadLicenseTask}
                  changeOwner={
                    getValue(props, `permissions`, []).includes("view_all")
                      ? true
                      : false
                  }
                  isOpen={isOpen}
                  handleModal={
                    getValue(selectedIDs, `length`, 0) > 0
                      ? handleModal
                      : () => toast.error("Please select task")
                  }
                />
      </div>
    )}
  </div>
              </div>
            </div>

          </div>
          <div className="dashboard-wrapper__header d-flex align-items-center justify-content-between d-none">
            {/* <div className="d-flex align-items-center"> */}
            <div className="d-flex align-items-center flex-wrap header-right">
              <NavLink
                to={
                  getValue(params, `request_from`, "") === "dashboard"
                    ? `/dashboard/license?from_date=${getValue(
                      params,
                      `from_date`,
                      "",
                    )}&to_date=${getValue(params, `to_date`, "")}`
                    : `/activities/task/license?${queryRequest}`
                }
              >
                4444
                <img
                  src="/images/back-link.svg"
                  className="img-fluid add-filter-wrapper__upload-image"
                  alt=""
                />
              </NavLink>
              {/* <UncontrolledDropdown>
								<DropdownToggle caret>
									<div className="d-flex align-items-center">
										<h6 className="dashboard-wrapper__dropdown">
											{getValue(selectedCompliance, `length`, 0) > 0
												? getValue(
														selectedCompliance,
														`[${0}].location_name`,
														""
												  )
												: ""}
										</h6>
										<img
											src="/images/arrow-drop.svg"
											className="img-fluid add-filter-wrapper__upload-image"
										/>
									</div>
								</DropdownToggle>
								<DropdownMenu>
									{complianceTypeList.map((item) => {
										return (
											<DropdownItem
												onClick={() => {
													handleNavigate(getValue(item, `id`, ""));
												}}
											>
												{getValue(item, `location_name`, "")}
											</DropdownItem>
										);
									})}
								</DropdownMenu>
							</UncontrolledDropdown> */}

              {/* <Select
								placeholder="Search Location"
								options={complianceTypeList}
								onInputChange={searchLocations}
								onChange={handleSelectLocation}
							/> */}
              <FilterSearchDropdown
                placeholder={"Search Location"}
                options={complianceTypeList}
                searchLoading={searchLoading}
                handleChange={(val: any) => handleTriggerAPI(val)}
                handleClick={handleClick}
                value={selectedValue}
                label="label"
                id="id"
              />
            </div>
            <div className="d-flex align-items-center">
              <div className="no-bordered-input-calendar mr-2">
                <DatePicker
                  selectsRange={false}
                  selected={follow_up_date_from ? new Date(follow_up_date_from) : null}
                  className="react-date-picker__inputGroup__input"
                  onChange={(date: any) => {
                    if (date && follow_up_date_to && new Date(date) > new Date(follow_up_date_to)) {
                      toast.error("From Date cannot be greater than To Date");
                    } else {
                      handleFollowupDate([date, follow_up_date_to]);
                    }
                  }}
                  dateFormat="d MMM yyyy"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  placeholderText="Followup From Date"
                  maxDate={follow_up_date_to ? new Date(follow_up_date_to) : undefined}
                />
              </div>
              <div className="no-bordered-input-calendar mr-2">
                <DatePicker
                  selectsRange={false}
                  selected={follow_up_date_to ? new Date(follow_up_date_to) : null}
                  className="react-date-picker__inputGroup__input"
                  onChange={(date: any) => {
                    if (follow_up_date_from && date && new Date(follow_up_date_from) > new Date(date)) {
                      toast.error("To Date cannot be less than From Date");
                    } else {
                      handleFollowupDate([follow_up_date_from, date]);
                    }
                  }}
                  dateFormat="d MMM yyyy"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  placeholderText="Followup To Date"
                  minDate={follow_up_date_from ? new Date(follow_up_date_from) : undefined}
                />
              </div>
              <button
                className="dashboard-wrapper__apply-btn ml-2"
                onClick={handleSubmitFollowupDate}
              >
                Apply
              </button>
              &nbsp;&nbsp;&nbsp;
              <div className="no-bordered-input-calendar mr-2">
                <DatePicker
                  selectsRange={false}
                  selected={expiry_date_from ? new Date(expiry_date_from) : null}
                  className="react-date-picker__inputGroup__input"
                  onChange={(date: any) => {
                    if (date && expiry_date_to && new Date(date) > new Date(expiry_date_to)) {
                      toast.error("From Date cannot be greater than To Date");
                    } else {
                      handleExpiryDate([date, expiry_date_to]);
                    }
                  }}
                  dateFormat="d MMM yyyy"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  placeholderText="Expiry From Date"
                  maxDate={expiry_date_to ? new Date(expiry_date_to) : undefined}
                />
              </div>
              <div className="no-bordered-input-calendar mr-2">
                <DatePicker
                  selectsRange={false}
                  selected={expiry_date_to ? new Date(expiry_date_to) : null}
                  className="react-date-picker__inputGroup__input"
                  onChange={(date: any) => {
                    if (expiry_date_from && date && new Date(expiry_date_from) > new Date(date)) {
                      toast.error("To Date cannot be less than From Date");
                    } else {
                      handleExpiryDate([expiry_date_from, date]);
                    }
                  }}
                  dateFormat="d MMM yyyy"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  placeholderText="Expiry To Date"
                  minDate={expiry_date_from ? new Date(expiry_date_from) : undefined}
                />
              </div>
              <button
                className="dashboard-wrapper__apply-btn ml-2"
                onClick={handleSubmitExpiryDate}
              >
                Apply
              </button>
            </div>
          </div>
          <div className="main-page-layout-wrapper">
            <div className="admin-wrapper position-relative">
              <div className="admin-wrapper position-relative d-none">
                <SearchHeader
                  route={"/configuration/vendors/add"}
                  searchInput={search_text}
                  showSearchTextbox={showSearchTextbox}
                  toggleSearch={toggleSearch}
                  toggleSearchClose={toggleSearchClose}
                  handleChangeSearch={handleChangeSearch}
                  isBulkUploadVisible={false}
                  smartFilter={true}
                  setFilterFormVisibility={() => {
                    setFilterVisibility(!isFilterVisible);
                  }}
                  isFilterVisible={isFilterVisible}
                  add="false"
                  calender={true}
                  handleNavigateCalenderView={handleNavigateCalenderView}
                  id={
                    getValue(mainParams, `id`, "") === "id"
                      ? ""
                      : getValue(mainParams, `id`, "")
                  }
                  filterIsOpen={filterIsOpen}
                  handleFilter={() => {
                    setFilterIsOpen(!filterIsOpen);
                  }}
                />
              </div>

              {/* {isFilterVisible && ( */}
              <FilterForm
                setFilterFormVisibility={() => {
                  setFilterVisibility(!isFilterVisible);
                }}
                countryList={countryList}
                states={states}
                handleChangeSelect={handleChangeSelect}
                country_ID={country_ID}
                state_ID={state_ID}
                frequency_id={frequency_id}
                checkpoint_id={checkpoint_id}
                reset={reset}
                handleSubmitSmartFilter={handleSubmitSmartFilter}
                frequencyList={frequencyList}
                checkpointList={checkpointList}
                additionalFilter={true}
                smartFilterList={smartFilterList}
                handleChangeSelectMulti={handleChangeSelectMulti}
                selectedSmartFilterIds={selectedSmartFilterIds}
                request={request}
                //dynamic filter ( Custom Input Select Dropdown)
                //----> category of law
                categoryOfLawList={categoryOfLawList}
                getCategoryLawList={getCategoryLawList}
                categoryLawLoading={categoryLawLoading}
                cat_ID={cat_ID}
                //----> legislation
                legislationList={legislationList}
                getLegislationList={getLegislationList}
                legislationLoading={legislationLoading}
                leg_ID={leg_ID}
                //----> legislation rule
                ruleList={ruleList}
                getLegislationRuleList={getLegislationRuleList}
                rule_ID={rule_ID}
                legislationRuleLoading={legislationRuleLoading}
                //---->  location
                locations={locations}
                getLocationList={getLocationList}
                location_id={location_id}
                locationLoading={locationLoading}
                //---->  functions
                function_id={function_id}
                functions={functions}
                functionLoading={functionLoading}
                getLocationFunctions={getLocationFunctions}
                resetInput={resetInput}
                filterIsOpen={filterIsOpen}
                handleFilter={handleFilter}
                moduleName={"Activities"}
                subModuleName={"License"}
              />
              {/* )} */}

              {isLoading || !props.permissionAPITriggered ? (
                <Loader />
              ) : list.length > 0 ? (
                <ScrollableReactTable
                  columns={columns}
                  data={list}
                  getTableState={getTableState}
                  rowClick={rowClick}
                  check={check}
                  selectedIDs={selectedIDs}
                  getTrProps={getTrProps}
                />
              ) : (
                <>
                  {Object.keys(params).length !== 0 ? (
                    <>
                      <Notfound />
                    </>
                  ) : (
                    <Notfound />
                  )}
                </>
              )}
            </div>
            <div className="footer-wrapper d-flex justify-content-between">
              {list.length > 0 && (
                <img
                  src="/images/building-illustration.svg"
                  className="img-fluid"
                />
              )}
              {totalCount > 10 ? (
                <PaginationPage
                  totalCount={totalCount}
                  limit={limit}
                  pageNumber={page_no}
                  handleChangePagination={handleChangePagination}
                  handleChangeLimit={handleChangeLimit}
                />
              ) : (
                <p className="show-rows-count mt-3 d-flex">
                  Total Count:&nbsp;&nbsp;{" "}
                  <p style={{ color: "rgb(13, 110, 253)" }}>{totalCount}</p>
                </p>
              )}
            </div>
          </div>
          <DeleteModal
            isOpen={isDelete}
            handleModal={handleDelete}
            handleSubmit={handleDeleteFunction}
            deleteValue={deleteValue}
          />
        </>
      )}
      <ChangeOwnerModal
        isOpen={isOpen}
        userLoading={userLoading}
        submitUserLoading={submitUserLoading}
        userList={userList}
        request={request1}
        setRequest={setRequest1}
        handleModal={handleModal}
        handleSubmitChangeUser={handleSubmitChangeUser}
        handleChangeSelect={handleChangeSelectUser}
        getUsersList={getUsersList}
        changeOwnerType={"License"}
      />
    </DashboardLayout>
  );
};

export default ComplianceTaskList;
